// extracted by mini-css-extract-plugin
export default {"addressAction":"j6-z","loading":"k6-z"};